export default __webpack_public_path__ + "static/actionableinsights-8ed01ab786c020be46bbecbe39ecc722.png";